import { PropsWithChildren, createContext, useContext, useState } from 'react';
import { searchIndexes } from '../../search-shared/client';

type IndexNameContext = {
    indexName: string;
    setIndexName: (newIndexName: string) => void
}

const initialState = {
    indexName: searchIndexes.RECOMMENDED_PRODUCTS,
    setIndexName: () => {
        throw new Error('useIndexName must be used within the IndexNameProvider')
    },
};

const IndexNameContext = createContext<IndexNameContext>(initialState);

export const useIndexName = () => {
  const context = useContext(IndexNameContext);
  return context;
};

export const IndexNameProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [indexName, _setIndexName] = useState<string>(initialState.indexName);

  const setIndexName = (newIndexName: string) => {
    _setIndexName(newIndexName);
  };

  const value = {
    indexName,
    setIndexName,
  };

  return (
    <IndexNameContext.Provider value={value}>
      {children}
    </IndexNameContext.Provider>
  );
};